import { Component } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import UploadScanPreview from "modules/upload-scan-preview"
import Upload from "components/upload"
import UploadHeader from "components/upload/components/upload-header"
import UploadContainer from "components/upload/components/upload-container"
import UploadStep from "components/upload/components/upload-step"
import Stepper from "components/stepper"
import TagAndAttributeCreator from "modules/tag-and-attribute-creator"
import saveRecentResources from "hocs/saveRecentResources"

class PortfolioPositions extends Component {
  lastNotifiedPortfolioId = null

  static propTypes = {
    portfolioDetails: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
    navigate: PropTypes.func.isRequired,
    addNotification: PropTypes.func.isRequired,
    account: PropTypes.string.isRequired,
    resetUpload: PropTypes.func.isRequired,
    scanFiles: PropTypes.func.isRequired,
    files: PropTypes.array.isRequired,
    uploadOption: PropTypes.string.isRequired,
    activeStep: PropTypes.number.isRequired,
    confirmUpload: PropTypes.func.isRequired,
    steps: PropTypes.array.isRequired,
    addFiles: PropTypes.func.isRequired,
    removeFile: PropTypes.func.isRequired,
    uploadConfig: PropTypes.object.isRequired,
    scanResult: PropTypes.object,
    resetScan: PropTypes.func.isRequired,
    changeUploadOption: PropTypes.func.isRequired,
    uploadDateTime: PropTypes.object,
    uploadedFiles: PropTypes.array.isRequired,
    overlappingDates: PropTypes.array.isRequired,
    portfolioId: PropTypes.string.isRequired,
  }

  componentDidMount() {
    this.notifyFallbackModel()
  }

  componentDidUpdate() {
    this.notifyFallbackModel()
  }

  notifyFallbackModel = () => {
    const { portfolioDetails, addNotification } = this.props
    if (!portfolioDetails || portfolioDetails.type === "experiment" || !portfolioDetails.usingFallbackModel || this.lastNotifiedPortfolioId === portfolioDetails.id) {
      return
    }
    if (portfolioDetails.model) {
      addNotification("warning", null, `The portfolio's default model (${portfolioDetails.defaultModelId}) is not available. Using ${portfolioDetails.model} instead.`)
      this.lastNotifiedPortfolioId = portfolioDetails.id
    }
  }

  // TODO add 404 page when the portfolio doesn't exist
  onSubmit = () => {
    const { scanFiles, files, uploadOption, activeStep, confirmUpload, portfolioDetails } = this.props

    switch (activeStep) {
      case 0:
        scanFiles(files, portfolioDetails)
        break
      case 1:
        confirmUpload(uploadOption, portfolioDetails)
        break
    }
  }

  goToHome = () => {
    const { navigate, account } = this.props
    navigate(`/${account}/home/resources`)
  }

  render() {
    let rolloverLegend
    let legend
    const {
      account,
      portfolioId,
      portfolioDetails,
      params,
      navigate,
      addNotification,
      overlappingDates,
      files,
      uploadedFiles,
      scanResult,
      uploadOption,
      uploadDateTime,
      uploadConfig,
      activeStep,
      steps,
      addFiles,
      removeFile,
      resetScan,
      resetUpload,
      changeUploadOption,
    } = this.props

    if (portfolioDetails.type === "experiment") {
      rolloverLegend = `Alternative experiments will only be available in the experiment screen for ${portfolioDetails.parent.name}.`
      legend = <>To upload as a portfolio that can be accessible everywhere, visit the <button onClick={this.goToHome}>OP Home Screen</button> and create a new portfolio</>
    } else {
      rolloverLegend = portfolioDetails.live
        ? "This portfolio is set to rollover positions to current date."
        : "This portfolio is not set to rollover positions to current date."
    }

    let currentStep

    if (!params.step) {
      currentStep = <UploadStep
        addFiles={addFiles}
        files={files}
        removeFile={removeFile}
        addNotification={addNotification}
        uploadConfig={uploadConfig}
        docLink="https://support.ompnt.com/en/articles/78542-uploads-in-common-position-format"
        legend={legend}
      />
    } else if (params.step === "preview") {
      currentStep = <UploadScanPreview
        showOverrideOptions={portfolioDetails.type === "experiment"}
        overlappingDates={overlappingDates}
        target={portfolioDetails}
        uploadDateTime={uploadDateTime}
        type={portfolioDetails.type}
        scanResult={scanResult}
        resetScan={resetScan}
        uploadStep={steps[0]}
        changeUploadOption={changeUploadOption}
        uploadOption={uploadOption}
      />
    }

    return <Upload onCancel={resetUpload} className={classNames({ "upload-experiment": portfolioDetails.type === "experiment" })}>
      <UploadHeader
        type={portfolioDetails.type === "experiment" ? "Alternative Experiment" : portfolioDetails.type}
        target={portfolioDetails}
        rolloverLegend={rolloverLegend}
      />
      <UploadContainer>
        <Stepper
          goBack={() => { navigate(-1) }}
          steps={steps}
          activeStep={activeStep}
          disableVariables={{ files, uploadOption, uploadedFiles, overlappingDates, type: portfolioDetails.type }}
          onSubmit={this.onSubmit}
          stepComponent={currentStep}
        />
      </UploadContainer>
      <TagAndAttributeCreator {...{ account, resourceId: portfolioId, resourceType: "PORTFOLIO" }} />
    </Upload>
  }
}

export default saveRecentResources(PortfolioPositions, "portfolio.id")
